export default __webpack_public_path__ + "static/media/feature-team_tab_4.e1fc67b81b335f11079e298fe4e70a4f.svg";